var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PaginatedList',{attrs:{"queryName":"users","queryFields":"{\n      _id\n      email\n      profile {\n        name\n      }\n    }","searchBox":"","defaultIcon":"person","limit":20,"transformResult":_vm.transformResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }